<!-- 
	1. Verifica login, hay que estar identificado
	2. Opcion de ingreso
	  2.1 cartadd {articulo}-> agregar articulo a canasta del usuario
	  2.2 cartview {cartid?} -> cartid isnull, ver contenido de canasta abierta o aceptada sino ver contenido de canasta por id
	  2.3 cartlist {usuario?} -> ver lista de compras del usuario, si usuario es null y usuario logueado es ADMIN, listar todo
 -->

 <script>
 	import Login from '../usuarios/login.svelte'
 	import Registro from '../usuarios/registro.svelte'
 	import CartAdd from './CartAdd.svelte'
 	import CartView from './CartView.svelte'
 	import CartList from './CartList.svelte'
 	import CartForm from './CartForm.svelte'

 	import {execQuery, execMutation, execCheckStock,execRawMutation} from '../csql.js'
	
 	import {onMount} from 'svelte'
	import { usuario } from '../store.js'

 	export let articulo = {}
 	export let cartid = 0
 	export let comprador = ''
 	export let handler2 = () => console.log('Unhandled function')

 	let accion = ''

 	let email_a_registrar = ''

 	let loading = false

 	let ultimo =true

 	let filtro = 'CERRADO'

 	let pattern = ''
 	let page = 0

 	function handler(params){
		email_a_registrar = ''		
		if(params.response===-1){
			if(!confirm('Necesitamos tus datos para procesar tu compra, Quieres ingresarlos ahora?')) close()
		}else{
			if(params.view_dst==='registro'){
				email_a_registrar = params.email
				accion = 'registro'
			} else set_accion()
		}
		return
	}

	function cart_handler(args){
		if(args.goto==='catalogo') volverAlCatalogo()
		cartid = args.cartid || 0
		accion = args.goto || ''
		pattern = args.pattern || pattern
		page = args.page || page
		ultimo=false
	}

	function volverAlCatalogo(){
		handler2({goto:'catalogo'})
	}

	function set_accion(){
 			if(articulo.id) accion = 'cartadd'
 			else if(cartid>0) accion = 'cartview'
 			else {
 				if(comprador==='') comprador= $usuario.email
 				accion = 'cartlist'
 			}
	}

	function close(){
		accion = ''
	}

 	onMount( async () => {
 		if(!$usuario.email){
 			// creo usuario temporal
 			let d = new Date()
 			let uuid = d.getTime().toString()
 			let unique_email = "__fake__@"+uuid+".xxx"
 			let usr = {"email":unique_email,"tipo":"MINO","activo":1}
 			usuario.set(usr)
 			localStorage.setItem('UPM_USER',JSON.stringify({user:usr}))
 			accion = 'cartadd'
 		}else set_accion()

 	})
 </script>

<div class="modal">
	<div id="principal" style="width:100%;height:100%;background-color:white;position:relative;top:0;left:0;overflow:auto;">
		<div  style="text-align:center;background-color: #eeeeee;display: flex;justify-content: space-between;min-width:400px;">
			<button style="background-color: transparent;font-size: 1rem; padding:0;margin:0 15px;" on:click={volverAlCatalogo}>❤️ UP+</button>
		  <slot name="salir"></slot>
		</div> 
		
		{#if accion===''}
			<div>
				<p>Necesitar ingresar un email para realizar una compra.</p>
				<p><button on:click={volverAlCatalogo}>Regresar al Catalogo</button></p>
			</div>
		{/if}

		{#if accion === 'login' }
			<Login {handler}/>
		{/if}

		{#if accion === 'registro'}
			<Registro handler={handler} email={email_a_registrar }/>
		{/if}

		{#if accion === 'cartadd'}
			<CartAdd item={articulo} {cart_handler}/>
		{/if}

		{#if accion === 'cartview' }
			<CartForm {cartid} {cart_handler} expand="d"/>
		{/if}

		{#if accion === 'cartlist'}
			<CartList {cart_handler} {ultimo} bind:filtro={filtro} bind:pattern={pattern} bind:page={page}/>
		{/if}
			
	</div>
	<code style="color:#999;position:fixed;bottom:10px;right:0;">{accion}</code>
</div>